import { defineMessages } from "./define.js";

/** The share target: what arrived from another app, and saving it as a wish. */
export const share = defineMessages("share", {
  title: { ru: "Сохранить как хотелку", en: "Save as a wish" },
  inSpace: { ru: "В пространство «{name}»", en: "Into the “{name}” space" },

  whatCame: { ru: "Что пришло", en: "What came in" },
  noUrl: {
    ru: "Ссылки в этом «Поделиться» не было — сохраним текстом.",
    en: "There was no link in this share — we'll save it as text.",
  },
  // «длиннее» takes the genitive, so `one` is «символа» and not «символ».
  oversizedUrl: {
    ru: {
      one: "Адрес длиннее {count} символа — он не помещается в поле ссылки, поэтому уедет в заметку целиком.",
      few: "Адрес длиннее {count} символов — он не помещается в поле ссылки, поэтому уедет в заметку целиком.",
      many: "Адрес длиннее {count} символов — он не помещается в поле ссылки, поэтому уедет в заметку целиком.",
      other:
        "Адрес длиннее {count} символов — он не помещается в поле ссылки, поэтому уедет в заметку целиком.",
    },
    en: {
      one: "The address is over {count} character — it does not fit the link field, so it goes into the note in full.",
      other:
        "The address is over {count} characters — it does not fit the link field, so it goes into the note in full.",
    },
  },

  titleLabel: { ru: "Название", en: "Title" },
  titleHint: {
    ru: "Так хотелка будет называться в списке",
    en: "This is how the wish will read in the list",
  },
  saving: { ru: "Сохраняем…", en: "Saving…" },

  errorTitle: {
    ru: "Название нужно — хотя бы пара слов",
    en: "A title is needed — a couple of words will do",
  },
  errorUrl: { ru: "Это не похоже на ссылку", en: "That does not look like a link" },
  errorNote: { ru: "Заметка слишком длинная", en: "The note is too long" },
  saveFailed: {
    ru: "Не удалось сохранить — нет связи",
    en: "Could not save — no connection",
  },

  signInTitle: { ru: "Сначала войдите", en: "Sign in first" },
  signInBody: {
    ru: "Ссылка приходит в пространство, а пространство — за входом. Войдите и поделитесь ещё раз: адрес не сохранился.",
    en: "A link arrives into a space, and a space is behind the sign-in. Sign in and share it again — the address was not kept.",
  },
  signInAction: { ru: "Войти", en: "Sign in" },

  emptyTitle: { ru: "Ничего не пришло", en: "Nothing came through" },
  emptyBody: {
    ru: "Приложение открыло этот экран, но ни ссылки, ни текста в нём не оказалось. Так бывает, когда «Поделиться» отдаёт файл или картинку — их сюда пока сохранить нельзя.",
    en: "The app opened this screen, but neither a link nor any text came with it. That happens when the share hands over a file or a picture — those cannot be saved here yet.",
  },
  emptyAction: { ru: "К хотелкам", en: "Back to wishes" },

  // Пространство зашифровано, ключа на устройстве нет. Сказать об этом прямо —
  // единственный честный выход: записать ссылку открытым текстом туда, где всё
  // остальное нечитаемо, хуже, чем не записать вовсе.
  lockedTitle: { ru: "Пространство заперто", en: "The space is locked" },
  lockedBody: {
    ru: "Оно зашифровано, а ключа на этом устройстве нет — сохранять нечем. Ссылка не сохранилась: откройте пространство и поделитесь ещё раз.",
    en: "It is encrypted and this device has no key, so there is nothing to save with. The link was not kept — unlock the space and share it again.",
  },
});
